import axios from "axios";
import { useState, useEffect } from "react";


function useCategorys() {
    const [data, setData] = useState([])

    useEffect(() => {
        axios.get('https://freedomkremenets.com/categorys/')
        .then(res => {
            setData(res.data);
        }).catch(error => {
            console.log(error)
        });

    }, [])

    return data
}

export default useCategorys;
